import { ApiError, useApiClient } from "@myplant-io/utils/api";
import { useMutation, useQueryClient } from "react-query";
import { ModeStoreEntry } from "../types";

export function useModeStoreEntryPublish() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<
    ModeStoreEntry,
    ApiError,
    { mode_id: string; description: string }
  >(
    ({ mode_id, description }) => {
      return client.fetch<ModeStoreEntry>(`/api/mode-store`, {
        method: "POST",
        body: JSON.stringify({ mode_id, description }),
      });
    },
    {
      async onSettled() {
        queryClient.invalidateQueries("mode-store");
        queryClient.invalidateQueries("modes");
      },
    }
  );
}
